import React, { useState, useRef, useEffect } from "react";
import * as Yup from "yup";
import { Form, Formik, ErrorMessage } from "formik";
import { useHistory } from "react-router-dom";

import Button from "./FormElements/Button";

import CloseModal from "../Resources/svg/close-modal.svg";
import IconUpload from "../Resources/svg/icon-upload.svg";
import IconUploadDisabled from "../Resources/svg/icon-upload-disabled.svg";
import IconFile from "../Resources/svg/icon-file.svg";
import ProgressLoading from "./ProgressLoading";
import { API } from "aws-amplify";
import { decryptEstandar } from "../Utils/CryptographyUtils";
import { useSelector } from "react-redux";

let interval;

const ModalAttach = ({ data, open, setOpen }) => {
  const history = useHistory();
  const inputRef = useRef("");
  const [file, setFile] = useState();
  const [dragEffect, setDragEffect] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [running, setRunning] = useState(false);
  const [progress, setProgress] = useState(0);
  const [loadingClick, setLoadingClick] = useState(false);
  const [datosParticulares, setDatosParticulares] = useState({});
  const [failApiEmision, setFailApiEmision] = useState(false);
  const [nameFile, setNameFile] = useState("");

  const userLogin = useSelector((state) =>
    decryptEstandar(state.login.idClient)
  );

  const switchImagen = file
    ? IconUploadDisabled
    : showLoading
    ? IconUploadDisabled
    : IconUpload;

  const handleCloseModal = (resetForm) => {
    setOpen(false);
    document.body.style.overflow = "auto";
    handleRemoveFile();
    resetForm();
  };

  const handleOpenFile = () => {
    if (!file) {
      inputRef.current.click();
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!file && e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFile(e.dataTransfer.files[0]);
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    inputRef.current.value = "";

    setRunning(false);
    setProgress(0);
    setShowLoading(false);
  };

  const defaultFormShape = {
    payment: "",
    document: "",
    vaucher: null,
  };

  useEffect(() => {
    if (running) {
      interval = setInterval(() => {
        setProgress((prev) => prev + 1);
      }, 10);
    } else {
      clearInterval(interval);
    }
  }, [running]);

  useEffect(() => {
    if (progress === 80) {
      setRunning(false);
    }
  }, [progress]);

  const validarData = Object.keys(data).length === 0;

  useEffect(() => {
    if (!validarData) {
      const {
        codigoAsesor,
        datosCliente: {
          datosParticulares: { names, firstName, lastName, document },
          nombres,
        },
        datosCotizacion: {
          prima,
          moneda,
        },
        producto:{
          codigo
        }
      } = data;

      setDatosParticulares({
        emailAsesor: userLogin,
        codigoAsesor,
        names,
        nombres,
        firstName,
        lastName,
        document,
        prima,
        moneda,
        producto: codigo,
      });
    }
  }, [data]);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleSubmitData = async (values) => {
    setFailApiEmision(false);
    setLoadingClick(true);
    setFile(false);
    setShowLoading(true);

    setRunning(true);
    const { payment, document, vaucher } = values;
    const result = await toBase64(vaucher);

    try {
      const payloadEmision = {
        body: {
          idCotizacion: data.idCotizacion,
          metodo_pago: payment,
          nro_operacion: document,
          pathVoucher: result,
          nameFileVoucher: vaucher.name,
          datosParticulares,
        },
      };

      const response = await API.post(
        "api-rentas",
        "/sustento-emision",
        payloadEmision
      );
      if (response.data !== null) {
        interval = setInterval(() => {
          setProgress((prev) => prev + 1);
        }, 10);

        history.push("/cotizaciones/solicitud-cotizacion", {
          loadFile: true,
        });
        
        setRunning(false);
        setLoadingClick(false);
        clearInterval(interval);
      }
      if (!response.status) {
        inputRef.current.value = "";

        setRunning(false);
        setProgress(0);
        setShowLoading(false);
        clearInterval(interval);
        setFailApiEmision(true);

        setTimeout(() => {
          setFailApiEmision(false);
        }, 3000);
      }
    } catch (error) {
      setFailApiEmision(false);
      console.log(error);
      setRunning(false);
      setLoadingClick(false);
      clearInterval(interval);
    }

    setTimeout(() => {
      setRunning(false);
      setLoadingClick(false);
      clearInterval(interval);
    }, 2210);
  };

  const MAX_FILE_SIZE = 2 * 1024 * 1024;

  const validFileExtensions = { image: ["jpg", "png", "pdf", "jpeg"] };

  function isValidFileType(fileName, fileType) {
    return (
      fileName &&
      validFileExtensions[fileType].indexOf(fileName.split(".").pop()) > -1
    );
  }

  const schema = Yup.object().shape({
    payment: Yup.string().required("*Requiere seleccionar metodo de pago."),
    document: Yup.string()
      .required("*Requiere máximo 13 dígitos alfanumérico.")
      .max(13, "*Requiere máximo 13 dígitos alfanumérico."),
    vaucher: Yup.mixed()
      .required(".*Requiere adjuntar un archivo valido")
      .test(
        "is-valid-type",
        "El archivo no cargó porque el formato no es el permitido.",
        (value) => isValidFileType(value && value.name.toLowerCase(), "image")
      )
      .test(
        "is-valid-size",
        "El archivo no cargó porque excede la capacidad máxima (10 MB).",
        (value) => value && value.size < MAX_FILE_SIZE
      ),
  });

  const handleDragEffect = () => {
    setDragEffect((v) => !v);
  };

  return (
    <div className="modalAttach">
      <div className={`modal is-fullscreen ${open ? "open" : ""}`}>
        <div className="wrap">
          <div className="content-box">
            <Formik
              initialValues={defaultFormShape}
              validationSchema={schema}
              onSubmit={(values) => handleSubmitData(values)}
            >
              {(props) => (
                <div>
                  <div className="attach-close">
                    <div onClick={() => handleCloseModal(props.resetForm)}>
                      <span>Cerrar</span>
                      <img src={CloseModal} alt="cerrar" />
                    </div>
                  </div>
                  <div className="attach-container">
                    <div className="attach-container_head">
                      <h3 className="attach-container_head__title">
                        Adjuntar voucher
                      </h3>
                      <p className="attach-container_head__text">
                        Ingresa la información que recibiste de tu cliente:{" "}
                        <span>{datosParticulares.nombres}</span>
                      </p>
                    </div>
                    <Form>
                      <div className="attach-container_body">
                        <div className="attach-container_body__inputs">
                          <div>
                            <select
                              onChange={(e) => props.handleChange(e)}
                              onBlur={(e) => props.handleBlur(e)}
                              name="payment"
                              value={props.values.payment}
                            >
                              <option value="" disabled>
                                Método de pago
                              </option>
                              <option value="servicios">
                                Pago de servicios
                              </option>
                              <option value="transferencia">
                                Pago por transferencia
                              </option>
                              <option value="deposito">
                                Depósito en cuenta
                              </option>
                            </select>
                            
                            {props.errors.payment && (
                              <span className="message-error-form">
                                {props.errors.payment}
                              </span>
                            )}
                           
                          </div>
                          <div className="input-field">
                            <input
                              label="N° de operación"
                              name="document"
                              onChange={(e) => props.handleChange(e)}
                              value={props.values.document}
                              onBlur={(e) => props.handleBlur(e)}
                              type="text"
                              placeholder="N° de operación"
                              maxLength={13}
                            />

                            {props.errors.document && (
                              <span className="message-error-form">
                                {props.errors.document}
                              </span>
                            )}
                           
                          </div>
                        </div>
                        <div
                          className={`attach-container_body__dropbox ${
                            !file ? "" : "drop-disabled"
                          } ${dragEffect && "dopping"} 
                          ${showLoading && "drop-disabled"}
                        `}
                          onDrop={handleDrop}
                          onDragEnter={handleDragEffect}
                          onDragLeave={handleDragEffect}
                          onDragOver={handleDrop}
                        >
                          <input
                            name="vaucher"
                            ref={inputRef}
                            type="file"
                            onBlur={(e) => props.handleBlur(e)}
                            onChange={(event) => {
                              props.setFieldValue(
                                "vaucher",
                                event.currentTarget.files[0]
                              );
                              setFile(event.currentTarget.files[0]);
                              setNameFile(event.currentTarget.files[0].name);
                            }}
                            accept="image/jpg, image/png, image/jpeg, application/pdf"
                          />
                          <img src={switchImagen} alt="cargar" />
                          <p>
                            Arrastra el voucher a esta área o{" "}
                            <span onClick={handleOpenFile}>haz click aquí</span>
                          </p>
                          <span>
                            Máximo 1 archivo de 10 MB - Formatos JPG, JPEG, PNG y PDF
                            .
                          </span>
                        </div>
                      
                        <ErrorMessage
                          className="message-error-form"
                          name="vaucher"
                          component="span"
                        />
                        {props.errors.vaucher && (
                          <span className="message-error-form">
                            {props.errors.vaucher}
                          </span>
                        )}
                        {showLoading && (
                          <ProgressLoading
                            progress={progress}
                            setFieldValue={props.setFieldValue}
                            handleRemoveFile={handleRemoveFile}
                            nameFile={nameFile}
                          />
                        )}

                        {file && (
                          <div className="attach-container_body__file">
                            <div className="attach-container_body__file-name">
                              <img src={IconFile} alt="archivo" />
                              <span>{file && file.name}</span>
                            </div>

                            <span
                              className="attach-container_body__file-delete"
                              onClick={() => {
                                props.setFieldValue("vaucher", "");
                                handleRemoveFile();
                              }}
                            >
                              eliminar
                            </span>
                          </div>
                        )}
                      </div>
                      {failApiEmision && (
                        <span className="message-error-form">
                          Uy! Tenemos un error interno, prueba más tarde.
                        </span>
                      )}
                      <div className="attach-container_footer">
                        <div>
                          <Button
                            type="submit"
                            className={loadingClick ? "is-loading" : ""}
                            disabled={!props.isValid}
                          >
                            Continuar
                          </Button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAttach;
